import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=d3738754"
import script from "./CategoryModal.ts?vue&type=script&lang=ts&external"
export * from "./CategoryModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports